import { render } from "./searchInfo.vue?vue&type=template&id=67218fb9"
import script from "./searchInfo.vue?vue&type=script&lang=js"
export * from "./searchInfo.vue?vue&type=script&lang=js"

import "./searchInfo.vue?vue&type=style&index=0&id=67218fb9&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__